/**
 * DetailPhoto component.
 */
import DeviceConfig from '@devices/config';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled detail photo.
 */
const DetailPhoto = styled.img<React.CSSProperties>`
  position: absolute;
  right: 0;
  height: ${Screen.widthRatio * 845}px;
  width: ${Screen.widthRatio * 1500}px;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
`;

export default withImage(DetailPhoto);
